import { z } from "zod";

import {
  AvailableOrganisationArraySchema,
  ExtendedOrganisationArraySchema,
  type AvailableOrganisationArray,
  type ExtendedOrganisationArray,
} from "./organisation.js";

/// GetAvailableOrganisations

export const GetAvailableOrganisationsResponseSchema =
  AvailableOrganisationArraySchema;

export type GetAvailableOrganisationsResponse = AvailableOrganisationArray;

/// SearchOrganisations

export type SearchOrganisationsResponseUnbranded = {
  results: ExtendedOrganisationArray;
  count: number;
};

export const SearchOrganisationsResponseSchema = z
  .object({
    results: ExtendedOrganisationArraySchema,
    count: z.number(),
  })
  .brand<"vision-common:SearchOrganisationsResponse">();

export type SearchOrganisationsResponse =
  z.infer<
    typeof SearchOrganisationsResponseSchema
  > extends SearchOrganisationsResponseUnbranded
    ? z.infer<typeof SearchOrganisationsResponseSchema>
    : never;
